export interface CheckInputResult {
    valid: boolean;
    message: string;
}

export function isEmail(email: string) : boolean {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}
export function isInteger(input: string) : boolean {
    return /^-?\d+$/i.test(input);
}
export function checkPassword(password: string, minLength : number = 8, maxLength : number = 16) : CheckInputResult {
    if (password !== password.trim()) {
        return { valid: false, message: "Starts/ends with white space" };
    }
    if (minLength > maxLength) {
        return { valid: false, message: `Min length (${minLength}) more than Max length (${maxLength})` };
    }

    var lowercaseCount = 0;
    var uppercaseCount = 0;
    var digitCount = 0;
    var specialCount = 0;
    var whiteSpaceCount = 0;
    for (var i = 0; i < password.length; i++) {
        var ch = password.charAt(i);
        if (ch !== ch.trim()) {
            whiteSpaceCount++;
        } else if (ch !== ch.toLowerCase()) {
            uppercaseCount++;
        } else if (ch != ch.toUpperCase()) {
            lowercaseCount++;
        } else if (!isNaN(parseInt(ch))) {
            digitCount++;
        } else {
            specialCount++;
        }       
    }
    if (lowercaseCount <= 0) {
        return { valid: false, message: "No lower case letter" };
    }
    if (uppercaseCount <= 0) {
        return { valid: false, message: "No upper case letter" };
    }
    if (digitCount <= 0) {
        return { valid: false, message: "No digit" };
    }
    if (specialCount <= 0) {
        return { valid: false, message: "No special character" };
    }
    if (password.length < minLength) {
        return { valid: false, message: `Length (${password.length}) less than ${minLength}` };
    }
    if (password.length > maxLength) {
        return { valid: false, message: `Length (${password.length}) more than ${maxLength}` };
    }
    return { valid: true, message: "" };
}

export function checkInput(input: string, required: boolean = true, minLength?: number, maxLength?: number) : CheckInputResult {
    if (input.length === 0) {
        if (required) {
            return {valid: false, message: "Required"};
        }
    } else if (input.trim().length === 0) {
        return {valid: false, message: "Cannot be blank"};
    } else if (input.trim().length !== input.length) {
        return {valid: false, message: "Starts/ends with blanks"};
    } else if (minLength !== undefined && minLength > 0 && input.length < minLength) {
        return { valid: false, message: `Length (${input.length}) less than ${minLength}` };
    } else if (maxLength !== undefined && maxLength > 0 && input.length > maxLength) {
        return { valid: false, message: `Length (${input.length}) greater than ${maxLength}` };
    }
    return {valid: true, message: ""};
}

export function checkIntInput(input: string, required: boolean = true, min?: number, max?: number) : CheckInputResult {
    var result = checkInput(input, required);
    if (!result.valid || input.length === 0) {
        return result;
    }
    if (!isInteger(input)) {
        return {valid: false, message: "Invalid integer"};
    }
    var intValue = parseInt(input);
    if (isNaN(intValue)) {
        return {valid: false, message: "Invalid integer."};
    }
    var sIntValue = intValue.toString();
    if (input !== sIntValue) {
        return {valid: false, message: "Invalid integer.."};
    }
    var inRange = true;
    var message = "";
    if (min !== undefined && min !== null && intValue < min) {
        inRange = false;
        message = `Less than ${min}`;
    } else if (max !== undefined && max !== null && intValue > max) {
        inRange = false;
        message = `Greater than ${max}`;
    }
    if (!inRange && min !== undefined && min !== null && max !== undefined && max !== null) {
        message = `Not in range ${min}-${max}`;
    }
    return {valid: inRange, message: message};
}

export function isHexcodeColor(color: string) : boolean {
    return /^#([A-Fa-f0-9]{6})$/i.test(color);
}

export function checkColor(input: string, required: boolean = true) : CheckInputResult {
    var result = checkInput(input, required);
    if (!result.valid || input.length == 0) {
        return result;
    }
    var valid = isHexcodeColor(input);
    if (!valid) {
        result.valid = false;
        result.message = "Invalid Hexcode color";
    }
    return result;
}
